import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";

import { useProfile } from "Common/Hooks/UserHooks";

import { fetchLatestPermissions } from "slices/auth/login/thunk";
import { logoutUser } from "slices/thunk";

const VerifyAuthPermissions = (props: any) => {
  
  const latestPermissions = JSON.parse(localStorage.getItem("userPermissions") || "[]");
  console.log("latestPermissions",latestPermissions);

  const { permissions } = props;

  let hasPermission = true;

  if (permissions) {
    const { app_name, module_name, action } = permissions;
    const app_permissions = latestPermissions.find(
      (app: any) => app.apps_name === app_name
    );
    if (!app_permissions) {
      hasPermission = false;
    } else {
      const module_permissions = app_permissions.modules_permissions?.find(
        (module: any) => module.modules_name === module_name
      );
      if (!module_permissions) {
        hasPermission = false;
      } else {
        hasPermission = !!module_permissions.permissions?.[action];
      }
    }
  }
  
  if (!hasPermission) {
    return <Navigate to="/dashboard" />;
  }

  return <>{props.children}</>;
};

const AuthProtected = (props: any) => {
  const dispatch = useDispatch<any>();
  const { userProfile, loading, token } = useProfile();
  const permissionsLoading = useSelector((state: any) => state.Login.loading);


  useEffect(() => {
    const fetchPermissions = async () => {
      await dispatch(fetchLatestPermissions());
    };
    fetchPermissions();
  }, [dispatch]);

  // console.log("PROPS in authprotected :: ", props);
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */
  //  if (permissionsLoading) {
  //   return <div>Loading...</div>; 
  // }

  if (!userProfile && loading && !token) {
    return (
      <Navigate to={{ pathname: "/login" }} />
    );
  }

  return <>
    <VerifyAuthPermissions permissions={props.permissions}>
      {props.children}
    </VerifyAuthPermissions>
  </>
};


const AccessRoute = ({ component: Component, ...rest }: any) => {
  return (
    <Route
      {...rest}
      render={(props: any) => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AccessRoute, AuthProtected };
